import { render, staticRenderFns } from "./gestionar_reparaciones.vue?vue&type=template&id=16a52efb&"
import script from "./gestionar_reparaciones.vue?vue&type=script&lang=js&"
export * from "./gestionar_reparaciones.vue?vue&type=script&lang=js&"
import style0 from "./gestionar_reparaciones.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports